import React from 'react';
import Stacked from './Stacked';
import TreeMap from './TreeMap';
import WidgetPanel from '../WidgetPanel';
import NetworkContext from '../context';

const ResponseCode = () => {
  const { enableSSF, enableTimeSlice } = React.useContext(NetworkContext);

  return (
    <WidgetPanel title="Network Request Response Code" enableSSF={enableSSF} enableTimeSlice={enableTimeSlice}>
      {
        ({ stacked, treemap, chartType }) => {
          return (
            <>
              {stacked && chartType === 'stacked' && <Stacked />}
              {treemap && chartType === 'treemap' && <TreeMap />}
            </>
          )
        }
      }
    </WidgetPanel>
  )
}

export default ResponseCode;
